import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined, CrownOutlined } from "@ant-design/icons";
import { _get_ambassador_status } from "../common/axios_services";
import AppRoutes from "../common/routes";

const AmbassadorIncompleteModal = ({ userData }) => {
  const [visible, setVisible] = useState(false);
  const [checking, setChecking] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAmbassadorStatus = async () => {
      if (!userData || !userData.isAmbassador) return;

      setChecking(true);
      try {
        const res = await _get_ambassador_status();
        const data = res.data?.data || res.data || {};

        const hasFollowers = !!data.ambassadorFollowersRange;
        const hasSocialUrl =
          !!data.ambassadorIgUrl ||
          !!data.ambassadorTiktokUrl ||
          !!data.ambassadorFacebookUrl;
        const hasPosts =
          Array.isArray(data.ambassadorTopPosts) &&
          data.ambassadorTopPosts.length > 0;

        if (!hasFollowers || !hasSocialUrl || !hasPosts) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      } catch (err) {
        console.error("Failed to check ambassador profile status:", err);
      } finally {
        setChecking(false);
      }
    };

    checkAmbassadorStatus();
  }, [userData]);

  const handleUpdateClick = () => {
    setVisible(false);
    navigate(AppRoutes.become_ambassador + "?tab=onboarding#ambassador-profile-data-form");
  };

  if (!visible) return null;

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      centered
      className="ambassador-update-modal"
      width={460}
    >
      <div className="text-center p-4 space-y-4">
        <div className="w-16 h-16 bg-green-50 border-2 border-green-200 rounded-2xl mx-auto flex items-center justify-center text-3xl">
          👑
        </div>

        <div>
          <h2 className="font-gilroyBold text-2xl text-black m-0 mb-1">
        Update Your Ambassador Portal
          </h2>
          <p className="text-gray-500 text-[15px] m-0 leading-relaxed">
            Welcome back! You are registered as a Konnect Ambassador, but your social media profiles and audience metrics need to be completed.
          </p>
        </div>

        <div className="bg-amber-50 border border-amber-200 p-3.5 rounded-xl text-left space-y-1 text-[14px]">
          <p className="font-extrabold text-amber-800 m-0">Missing Information Notice:</p>
          <ul className="list-disc pl-5 m-0 text-amber-900 font-medium space-y-1">
            <li>Social Media Profile URLs (Instagram, TikTok, Facebook)</li>
            <li>Audience & Followers Range</li>
            <li>Links to your top 5 best posts</li>
          </ul>
        </div>

        <div className="pt-2">
          <Button
            type="primary"
            size="large"
            block
            icon={<EditOutlined />}
            onClick={handleUpdateClick}
            className="bg-[#16a34a] hover:bg-[#15803d] text-white font-extrabold text-[15px] h-[48px] rounded-xl border-none shadow-md"
          >
          UPDATE AMBASSADOR PORTAL NOW
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AmbassadorIncompleteModal;
